'use client';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { List, ListItem } from '@mui/material';
import { FooterListTitle } from './FooterListTitle';
import { styled } from '@mui/material/styles';
import { excludeComponentProps } from '../utils/excludeComponentProps';
const StyledList = styled(List, {
    ...excludeComponentProps('column', 'spacing')
})(({ column, spacing }) => {
    const pRem = spacing && spacing / 4;
    return {
        width: '100%',
        ...!column && {
            display: 'flex',
            flexDirection: 'row',
            flexWrap: 'wrap',
            justifyContent: 'center',
            li: {
                width: 'auto',
                marginLeft: `${pRem}rem`,
                marginRight: `${pRem}rem`
            }
        }
    };
});
export const FooterList = React.forwardRef(({ children, column = false, title, spacing = 2, FooterListTitleProps, ...props }, ref) => (_jsxs(StyledList, { column: column, dense: true, disablePadding: true, ref: ref, spacing: spacing, ...props, children: [title &&
            _jsx(ListItem, { disableGutters: true, children: _jsx(FooterListTitle, { text: title, ...FooterListTitleProps }) }), React.Children.map(children, (child, index) => (_jsx(ListItem, { disableGutters: true, children: child }, `list-item-${index}`)))] })));
FooterList.displayName = 'FooterList';
